import { UseMutationResult, useMutation } from 'react-query'
import request from '../request'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

type DataType = { agency_id: number; month?: string; client?: string; number?: string }

export const useDownloadInvoiceDetails = (): UseMutationResult<any, any, any> => {
  return useMutation<any, any, any>((data: DataType) => {
    return request({
      url: `/agencies/${data.agency_id}/invoices/details/download`,
      method: 'GET',
      params: {
        ...data,
      },
      credentials: 'include',
    })
  })
}
